import { boot } from 'quasar/wrappers'
import axios from 'axios'
import * as Sentry from '@sentry/vue'

function attachSentryInterceptor (instance, name) {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      try {
        const status = error?.response?.status
        const isNetwork = !error?.response
        if (isNetwork || (typeof status === 'number' && status >= 500)) {
          Sentry.captureException(error, {
            tags: { axios_instance: name, http_status: status ?? 'network' },
            extra: {
              url: error?.config?.url,
              method: error?.config?.method,
              baseURL: error?.config?.baseURL,
              // errorId do envelope de erro da API panel (rotas /genai):
              // correlaciona o evento Sentry com o log completo no servidor.
              errorId: error?.response?.data?.error?.errorId,
            },
          })
        }
      } catch (e) {
        // sentry pode não estar inicializado
      }
      return Promise.reject(error)
    }
  )
  return instance
}

// Be careful when using SSR for cross-request state pollution
// due to creating a Singleton instance here;
// If any client changes this (global) instance, it might be a
// good idea to move this instance creation inside of the
// "export default () => {}" function below (which runs individually
// for each client)
const PANEL_URL = process.env.VUE_APP_API_PANEL
const AUTH_URL = process.env.VUE_APP_API_AUTH;
const BROADCAST_URL = process.env.VUE_APP_API_BROADCAST;
const TELEGRAM_URL = process.env.VUE_APP_API_TELEGRAM;
const LIVE_URL = process.env.VUE_APP_API_LIVE_DEV;
const INTEGRATIONS_URL = process.env.VUE_APP_API_INTEGRATIONS;
const REPORTS_URL = process.env.VUE_APP_API_REPORTS;
const CDN_URL = process.env.VUE_APP_API_CDN;
const GLOBALBOT_WHATSAPP =  process.env.VUE_APP_GLOBALBOT_WHATSAPP

export default boot(({ app }) => {
  app.config.globalProperties.$axios = { ...axios.create({}) }
  app.config.globalProperties.$axios.defaults.baseURL = PANEL_URL
  attachSentryInterceptor(app.config.globalProperties.$axios, 'default')
  // Default object
  app.config.globalProperties.$API = {}
  // API Auth
  app.config.globalProperties.$API.auth = { ...axios.create({}) }
  app.config.globalProperties.$API.auth.defaults.baseURL = AUTH_URL
  attachSentryInterceptor(app.config.globalProperties.$API.auth, 'auth')
  // API Panel
  app.config.globalProperties.$API.panel = { ...axios.create({}) }
  app.config.globalProperties.$API.panel.defaults.baseURL = PANEL_URL
  attachSentryInterceptor(app.config.globalProperties.$API.panel, 'panel')
  // API Broadcast
  app.config.globalProperties.$API.broadcast = { ...axios.create({}) }
  app.config.globalProperties.$API.broadcast.defaults.baseURL = BROADCAST_URL
  attachSentryInterceptor(app.config.globalProperties.$API.broadcast, 'broadcast')
  // API Telegram
  app.config.globalProperties.$API.telegram = { ...axios.create({}) }
  app.config.globalProperties.$API.telegram.defaults.baseURL = TELEGRAM_URL
  attachSentryInterceptor(app.config.globalProperties.$API.telegram, 'telegram')
  // API Live
  app.config.globalProperties.$API.live = { ...axios.create({}) }
  app.config.globalProperties.$API.live.defaults.baseURL = LIVE_URL
  attachSentryInterceptor(app.config.globalProperties.$API.live, 'live')
  // API Integrations
  app.config.globalProperties.$API.integrations = { ...axios.create({}) }
  app.config.globalProperties.$API.integrations.defaults.baseURL = INTEGRATIONS_URL
  attachSentryInterceptor(app.config.globalProperties.$API.integrations, 'integrations')
  // API Reports
  app.config.globalProperties.$API.reports = { ...axios.create({}) }
  app.config.globalProperties.$API.reports.defaults.baseURL = REPORTS_URL
  attachSentryInterceptor(app.config.globalProperties.$API.reports, 'reports')
  // API CDN
  app.config.globalProperties.$API.cdn = { ...axios.create({}) }
  app.config.globalProperties.$API.cdn.defaults.baseURL = CDN_URL
  attachSentryInterceptor(app.config.globalProperties.$API.cdn, 'cdn')
  // API GLOBALBOT WhatsApp Broker
  app.config.globalProperties.$API.globalbotWhatsapp = { ...axios.create({}) }
  app.config.globalProperties.$API.globalbotWhatsapp.defaults.baseURL = GLOBALBOT_WHATSAPP
  attachSentryInterceptor(app.config.globalProperties.$API.globalbotWhatsapp, 'globalbotWhatsapp')

})
